module.exports = __webpack_public_path__ + "img/icon7.2e890b69.png";